import { Component } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'aps-spinner',
  template: `
    <div *ngIf="spinner.isVisible() | async" class="spinner">
      <div class="loading"></div>
    </div>
  `
})
export class SpinnerComponent {
  constructor(public spinner: SpinnerService) {
  }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/spinner/spinner.component.ts